import type { BaseQueryFn } from "@reduxjs/toolkit/query";
import axios, { AxiosError, type AxiosRequestConfig } from "axios";
import { serialize } from "object-to-formdata";
import { buildPath, globalLogout } from "../utils/helpers";

import {
  getLocalStorageAccessToken,
  //getLocalStorageRefreshToken,
} from "../utils/helpers/localStorage";
import { env } from "../env";
import { getAppUrl } from "../utils/defines";
import { addNotification } from "store/componentsSlice";

export const api = axios.create({
  baseURL: `${env.api_url}/`,
  //headers: { LanguageCode: DEFAULT_LANGUAGE },
});

api.interceptors.response.use(
  (config) => {

    if (config.data.hasError) {
      addNotification({
        type: 'error',
        message: config.data.message || "Something went wrong"
      });
    }
    return config;
  },
  (error) => {
    if (error.response?.status && error.response.data) {
      try {
        console.log(error.response.data.err.toString());
      } catch (e) { console.log(e); }

      console.log(error.response.status);

      switch (error.response.status) {
        case 403:
          break;
        case 404:
          break;
        case 401:
        case 498:
          globalLogout();
          window.location.href = getAppUrl("/");
          break;
        default:
          console.log('error default');
          break;
      }

      // if (err.response.status === 401) {
      //   const refreshToken = getLocalStorageRefreshToken();
      //   if (refreshToken && refreshToken !== "undefined") {
      //     //
      //   } else {
      //     removeAuthTokens();
      //     window.location.href = APP_URL.Login;
      //   }
      // } else if (err.response.status === 403) {
      //   window.location.href = "/";
      // }

    }
    return Promise.reject(error);
});

api.interceptors.request.use((config) => {
  const token = getLocalStorageAccessToken();
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

export const query =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: "" }
  ): BaseQueryFn<
    {
      url: string;
      baseUrl?: string;
      method: AxiosRequestConfig["method"];
      data?: AxiosRequestConfig["data"];
      params?: AxiosRequestConfig["params"];
      headers?: AxiosRequestConfig["headers"];
      isJson?: boolean;
      responseType?: string;
    },
    unknown,
    unknown
  > =>
    async ({ url, method, data, params, headers, baseUrl: overriddenBaseUrl, isJson, responseType }) => {
      if (data && !isJson) {
        data = formDataFromObject(data);
      }
      try {
        const result = await api({
          url: buildPath(
            typeof overriddenBaseUrl === "string" ? overriddenBaseUrl : baseUrl,
            url
          ),
          method,
          data,
          params,
          headers,
          responseType: responseType ?? 'json',
        } as any);
        return { data: result.data };
      } catch (axiosError) {
        let err = axiosError as AxiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    };

export function formDataFromObject(obj: any) {
  return serialize(obj, { indices: true });
}

export const setAuthHeader = (token: string) => {
  api.defaults.headers.Authorization = "Bearer " + token;
};

export const setLanguageHeader = (code: string) => {
  api.defaults.headers.LanguageCode = code;
};

export const removeAuthHeader = () => {
  api.defaults.headers.Authorization = null;
};
